import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Agent',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Agent',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Agent',
    column_type: 'datetime',
  },
  phone: {
    model_name: 'Agent',
    column_type: 'string',
  },
  locked_at: {
    model_name: 'Agent',
    column_type: 'datetime',
  },
  status: {
    model_name: 'Agent',
    column_type: 'enum',
  },
  name: {
    model_name: 'Agent',
    column_type: 'string',
  },
  ref_code: {
    model_name: 'Agent',
    column_type: 'string',
  },
  store_owner: {
    model_name: 'Agent',
    column_type: 'belongs_to',
    extra: {
      association_name: 'store_owner',
      model_name: 'StoreOwner',
      foreign_key: 'store_owner_id',
    },
  },
  store_owner_id: {
    model_name: 'Agent',
    column_type: 'belongs_to',
    extra: {
      association_name: 'store_owner',
      model_name: 'StoreOwner',
      foreign_key: 'store_owner_id',
    },
  },
  merchant: {
    model_name: 'Agent',
    column_type: 'belongs_to',
    extra: {
      association_name: 'merchant',
      model_name: 'Merchant',
      foreign_key: 'merchant_id',
    },
  },
  merchant_id: {
    model_name: 'Agent',
    column_type: 'belongs_to',
    extra: {
      association_name: 'merchant',
      model_name: 'Merchant',
      foreign_key: 'merchant_id',
    },
  },
  miapay_wallet_holder_attributes: {
    model_name: 'Agent',
    column_type: 'string',
  },
  can_reset_password: {
    model_name: 'Agent',
    column_type: 'string',
  },
  balance: {
    model_name: 'Agent',
    column_type: 'string',
  },
  cashback: {
    model_name: 'Agent',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
